import { __decorate } from "tslib";
import "jquery";
import 'bootstrap/dist/js/bootstrap.js';
import "popper.js";
import "tooltip.js";
import "perfect-scrollbar";
import "sticky-js";
import Vue from 'vue';
import Component from 'vue-class-component';
import TemplateHeader from '@/components/template/TemplateHeader.vue';
import TemplateBody from '@/components/template/TemplateBody.vue';
import ReactiveComponent from "@/components/ReactiveComponent";
import authService from "@/services/authService";
import { defaultRoutes } from "@/router";
import KTLayout from '@/assets/js/template/templateLayout';
import KTUtil from '@/assets/js/template/templateUtil';
let App = class App extends ReactiveComponent {
    constructor() {
        super(...arguments);
        this.sessionInitialized = false;
        this.validSession = false;
    }
    created() {
        this.subscribe('session', authService.session, (session) => {
            const sessionInitBefore = this.sessionInitialized;
            this.sessionInitialized = true;
            this.validSession = session.isValid;
            // Make navigation change only if session changed after the first loading
            // Otherwise url will be overridden to default location
            if (sessionInitBefore) {
                this.$router.push({ name: defaultRoutes.get(session.role) });
            }
            Vue.nextTick(function () {
                KTLayout.init();
            });
        });
    }
    mounted() {
        KTUtil.init({});
    }
};
App = __decorate([
    Component({
        components: { TemplateHeader, TemplateBody }
    })
], App);
export default App;
